import styled from 'styled-components';

import { Tooltip } from '@hqo/react-components-library/dist/atoms/tooltip';

export const CopyButton = styled.button`
  display: flex;
  border: none;
  background: none;
  padding: 0;
  color: inherit;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;

  &:focus-visible {
    opacity: 1;
  }

  @media (hover: none) {
    opacity: 1;
  }
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: 6px;

  .tooltip-text {
    white-space: nowrap;
  }
`;
